import React from 'react';
import { Icon, Button, Form } from 'antd';
import { Field } from 'redux-form';
import { TextField } from 'redux-form-antd';

import InlineMessage from '../../atoms/InlineMessage/index';
import GuestTemplate from '../../templates/GuestTemplate';

import './LoginForm.css';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
  },
};

const LoginForm = ({ authError, handleSubmit, loading, referrer }) => (
  <GuestTemplate>
    <Form onSubmit={handleSubmit} className="loginForm">
      {authError && <InlineMessage message={authError} type="error" className="message" />}
      {referrer && referrer !== '/campaigns/' && referrer !== '/campaigns' ? (
        <InlineMessage
          message={
            <span>
              Upon login, you will be redirected to <strong>{referrer}</strong>
            </span>
          }
          type="info"
          className="message"
        />
      ) : null}

      <Field
        {...formItemLayout}
        name="username"
        component={TextField}
        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
        placeholder="Email"
        type="email"
        size="large"
      />

      <Field
        {...formItemLayout}
        name="password"
        component={TextField}
        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
        type="password"
        placeholder="Password"
        size="large"
      />

      <Button
        type="primary"
        htmlType="submit"
        className="login-form-button"
        size="large"
        loading={loading}
      >
        Sign In
      </Button>
    </Form>
  </GuestTemplate>
);

export default LoginForm;
